import api from "./ajax";
import renderJobHistory from "./render-job-history";

document.addEventListener("DOMContentLoaded", function () {
	// Select all inputs where the name starts with "job-required_staff"
	const inputs = document.querySelectorAll('input[name^="job-required_staff"]');

	// Function to handle the visibility of the div based on input value
	function handleVisibility(roleId, value) {
		const staffAllocationDiv = document.getElementById(`staffAllocation${roleId}`);
		if (staffAllocationDiv) {
			if (value > 0) {
				staffAllocationDiv.style.display = 'block';
			} else {
				staffAllocationDiv.style.display = 'none';
			}
		}
	}

	inputs.forEach(input => {
		const roleId = input.getAttribute('id').match(/\d+/)[0]; // Extract role ID from input ID
		handleVisibility(roleId, input.value);


		input.addEventListener('input', function () {
			// Extract the integer from the name attribute (e.g., "job-required_staff[1]" -> 1)
			const name = input.getAttribute('name');
			const match = name.match(/\[(\d+)\]/);
			const staffId = match ? match[1] : null;

			if (staffId) {
				handleVisibility(staffId, input.value);

				// Try to find the element with ID "staffAllocation{staffId}"
				const staffAllocationElement = document.getElementById(`staffAllocation${staffId}`);

				if (staffAllocationElement) {
					// Find the span with the data attribute data-sp-value="staff-required"
					const spanElement = staffAllocationElement.querySelector('span[data-sp-value="staff-required"]');

					if (spanElement) {
						// Replace the inner content of the span with the value of the input
						spanElement.textContent = input.value;
					}
				}
			}
		});
	});

	// Add event listener for copy tally link
	document.addEventListener('click', function(e) {
		if (e.target.closest('.copy-tally-link')) {
			e.preventDefault();
			const link = e.target.closest('.copy-tally-link');
			const tallyUuid = link.getAttribute('data-tally-uuid');
			const jobId = link.getAttribute('data-job-id');
			const staffName = link.getAttribute('data-staff-name');

			// Construct the tally URL
			const tallyUrl = `${window.location.origin}/jobs/${jobId}/?tally=${tallyUuid}`;

			// Copy to clipboard
			navigator.clipboard.writeText(tallyUrl).then(() => {
				alert(`Access link copied to clipboard for ${staffName}`);
			}).catch(err => {
				console.error('Failed to copy:', err);
				alert('Failed to copy link to clipboard');
			});
		}

		// Add event listener for send tally link
		if (e.target.closest('.send-tally-link')) {
			e.preventDefault();
			const link = e.target.closest('.send-tally-link');
			const staffWorkingJobId = link.getAttribute('data-staff-working-job-id');
			const staffName = link.getAttribute('data-staff-name');

			if (confirm(`Send access link to ${staffName}?`)) {
				api.sendTallyAccessLink(staffWorkingJobId).then(response => {
					if (response.error) {
						alert('An error occurred sending the access link');
					} else {
						alert(response.body.message || 'Access link sent successfully');
					}
				});
			}
		}

		// Add event listener for toggle tally permission links
		if (e.target.closest('.toggle-tally-permission')) {
			e.preventDefault();
			const link = e.target.closest('.toggle-tally-permission');
			const staffWorkingJobId = link.getAttribute('data-staff-working-job-id');
			const currentPermission = link.getAttribute('data-current-permission') === 'true';
			const staffName = link.getAttribute('data-staff-name');
			const newPermission = !currentPermission;

			api.toggleCanAddTallyData(staffWorkingJobId, newPermission).then(response => {
				if (response.error) {
					alert('An error occurred updating tally data permission');
				} else {
					// Find the row containing this staff member
					const row = link.closest('tr');

					// Update the icon in the table
					const iconCell = row.querySelector('td:nth-child(4)');
					if (newPermission) {
						iconCell.innerHTML = '<i class="far fa-check"></i>';
					} else {
						iconCell.innerHTML = '<i class="far fa-times"></i>';
					}

					// Update the link itself
					link.setAttribute('data-current-permission', newPermission);
					if (newPermission) {
						link.innerHTML = '<i class="far fa-times"></i> Revoke Tally Permission';
					} else {
						link.innerHTML = '<i class="far fa-check"></i> Grant Tally Permission';
					}

					// Find the dropdown menu containing the link
					const dropdownMenu = link.closest('.dropdown-menu');

					// Find or remove the copy and send link menu items
					const copyLinkItem = dropdownMenu.querySelector('.copy-tally-link');
					const sendLinkItem = dropdownMenu.querySelector('.send-tally-link');

					if (newPermission) {
						// Permission granted - add the menu items if they don't exist
						if (!copyLinkItem) {
							// Find the toggle permission item
							const toggleItem = link.closest('li');

							// Get the tally UUID from the response
							const tallyUuid = response.body.tally_uuid || '';

							// Get the job ID from the current URL path (e.g., /jobs/40/)
							const pathParts = window.location.pathname.split('/');
							const jobId = pathParts[pathParts.indexOf('jobs') + 1];

							// Create copy link item
							const copyLi = document.createElement('li');
							copyLi.innerHTML = `
								<div class="dropdown-item">
									<a
										href="#"
										class="btn btn--link copy-tally-link"
										data-tally-uuid="${tallyUuid}"
										data-job-id="${jobId}"
										data-staff-name="${staffName}"
									>
										<i class="far fa-copy"></i> Copy Access Link
									</a>
								</div>
							`;
							toggleItem.parentNode.insertBefore(copyLi, toggleItem.nextSibling);

							// Create send link item
							const sendLi = document.createElement('li');
							sendLi.innerHTML = `
								<div class="dropdown-item">
									<a
										href="#"
										class="btn btn--link send-tally-link"
										data-staff-working-job-id="${staffWorkingJobId}"
										data-staff-name="${staffName}"
									>
										<i class="far fa-paper-plane"></i> Send Access Link
									</a>
								</div>
							`;
							copyLi.parentNode.insertBefore(sendLi, copyLi.nextSibling);
						}
					} else {
						// Permission revoked - remove the menu items
						if (copyLinkItem) {
							copyLinkItem.closest('li').remove();
						}
						if (sendLinkItem) {
							sendLinkItem.closest('li').remove();
						}
					}
				}
			});
		}
	});

	const addStaffModalEl = document.getElementById('allocateStaffModal');

	// If the modal exists, add an event listener to it when it opens
	if (addStaffModalEl) {
		addStaffModalEl.addEventListener('show.bs.modal', async function (event) {
			const button = event.relatedTarget;
			const roleId = button.getAttribute('data-sp-role');
			const jobId = button.getAttribute('data-sp-job');
			const roleName = button.getAttribute('data-sp-role-name');
			const searchInput = addStaffModalEl.querySelector('#searchStaff');

			// Add role name to the modal body .staff-type element
			const staffTypeEl = addStaffModalEl.querySelector('.staff-type');
			staffTypeEl.textContent = roleName;

			const staff = await api.getStaffByRoleJob(roleId, jobId);

			renderStaff(staff.body, addStaffModalEl, roleId, jobId);

			if (searchInput) {
				// Prevent form submission on enter
				searchInput.addEventListener('keydown', function (event) {
					if (event.keyCode === 13) {
						event.preventDefault();
					}
				});

				searchInput.addEventListener('blur', function (event) {
					event.preventDefault();
					searchStaff(event, roleId, jobId, addStaffModalEl);
				});

				searchInput.addEventListener('keyup', function (event) {
					event.preventDefault();
					if (event.keyCode === 13) {
						searchStaff(event, roleId, jobId, addStaffModalEl);
					}
				});
			}
		});

		// Add an event listener to the modal when it closes
		addStaffModalEl.addEventListener('hidden.bs.modal', function () {
			const tableBody = addStaffModalEl.querySelector('#selectStaffList tbody');

			// Add the loading row back to table
			tableBody.innerHTML = '<tr><td colspan="5"><i class="far fa-spinner spin"></i></td></tr>';
		});
	}

});

const searchStaff = async (event, roleId, jobId, modalEl) => {
	const search = event.target.value;
	const staff = await api.getStaffByRoleJob(roleId, jobId, search);

	renderStaff(staff.body, modalEl, roleId, jobId);
}

const renderStaff = (staff, modalEl, roleId, jobId) => {
	// Find the table body in #selectStaffList
	const tableBody = modalEl.querySelector('#selectStaffList tbody');

	// Clear the table body
	tableBody.innerHTML = '';

	// Loop through each staff member
	staff.forEach(staffMember => {
		// Create a new row
		const row = document.createElement('tr');

		// Create a new cell for the staff member's name
		const nameCell = document.createElement('td');
		
		// Add the name
		let nameContent = staffMember.full_name;
		
		// If there's a conflict, add the job number as a link
		if (staffMember.has_conflict && staffMember.conflict_job_id) {
			nameCell.textContent = nameContent + ' ';
			
			const jobLink = document.createElement('a');
			jobLink.href = `/jobs/${staffMember.conflict_job_id}/`;
			jobLink.textContent = `(assigned to #${staffMember.conflict_job_number})`;
			jobLink.style.color = 'red';
			jobLink.setAttribute('title', `Already allocated to job: ${staffMember.conflict_job_name || staffMember.conflict_job_number}`);
			jobLink.target = '_blank';
			
			nameCell.appendChild(jobLink);
		} else {
			nameCell.textContent = nameContent;
		}

		// Create a new cell for the staff member's experience
		const experienceCell = document.createElement('td');
		experienceCell.textContent = staffMember.experience_display;

		// Create a new cell for the can add tally data checkbox
		const canAddTallyCell = document.createElement('td');
		canAddTallyCell.classList.add('text-center');
		const canAddTallyCheckbox = document.createElement('input');
		canAddTallyCheckbox.type = 'checkbox';
		canAddTallyCheckbox.checked = false;
		canAddTallyCheckbox.classList.add('can-add-tally-checkbox-modal');
		canAddTallyCell.appendChild(canAddTallyCheckbox);

		const addCell = document.createElement('td');

		// Create a button and add to addCell
		const addButton = document.createElement('button');

		addButton.textContent = 'Add';
		addButton.classList.add('btn', 'btn--primary');
		addButton.dataset.staffId = staffMember.id;
		addButton.dataset.roleId = roleId;
		addButton.dataset.jobId = jobId;
		addCell.appendChild(addButton);

		addButton.addEventListener('click', async function () {
			const staffId = this.dataset.staffId;
			const roleId = this.dataset.roleId;
			const jobId = this.dataset.jobId;
			const jobHistoryList = $('#jobHistoryList');

			// Get the checkbox value from the same row
			const canAddTallyData = canAddTallyCheckbox.checked;

			api.addStaffToJob(staffId, roleId, jobId, canAddTallyData).then(response => {
				if (response.error) {
					alert('An error occurred');
				} else {

					// Get the data from the response
					const {staff, id: staffWorkingJobId, can_add_tally_data} = response.body;
					const {id, first_name, last_name, experience_display} = staff;

					// Add the staff member to the table
					addStaffToTable(
						roleId,
						id,
						`${first_name} ${last_name}`,
						experience_display,
						jobId,
						staffWorkingJobId,
						can_add_tally_data
					);

					// Update the Job History
					api.getJobHistory(jobId).then(response => {
						if (response.error) {
							return;
						}

						const jobHistoryHtml = renderJobHistory(response.body)

						// Build HTML for job history items and then replace html in history list
						jobHistoryList.html(jobHistoryHtml);

					});

					// Disable the button
					addButton.disabled = true;
				}
			});
		});

		// Append the cells to the row
		row.appendChild(nameCell);
		row.appendChild(experienceCell);
		row.appendChild(canAddTallyCell);
		row.appendChild(addCell);

		// Append the row to the table body
		tableBody.appendChild(row);
	});
}


const addStaffToTable = (roleId, staffId, staffName, experience, jobId, staffWorkingJobId, canAddTallyData) => {
	// Get the table element using the roleId
	const tableEl = document.getElementById(`allocatedStaffTable${roleId}`);

	if (!tableEl) {
		return;
	}

	// Remove the "No staff allocated yet" row if it exists
	const noResultsRow = tableEl.querySelector('.no-results');
	if (noResultsRow) {
		noResultsRow.remove();
	}

	// Create a new row
	const newRow = document.createElement('tr');

	// Create the HTML for the new row
	newRow.innerHTML = `
        <td>${staffId}</td>
        <td>${staffName}</td>
        <td>${experience}</td>
        <td class="text-center">
            ${canAddTallyData ? '<i class="far fa-check"></i>' : '<i class="far fa-times"></i>'}
        </td>
        <td class="text-center">
        </td>
        <td>
        	<div class="options-menu text-end">
				<button
						class="btn dropdown-toggle"
						type="button"
						id="dropdownMenuButton${roleId}${staffId}"
						data-bs-toggle="dropdown"
						aria-expanded="false"
				>
					<i class="far fa-ellipsis-h"></i>
				</button>
				<ul
						class="dropdown-menu"
						aria-labelledby="dropdownMenuButton${roleId}${staffId}"
				>
					<li>
						<div class="dropdown-item">
							<a
								href="#"
								class="btn btn--link toggle-tally-permission"
								data-staff-working-job-id="${staffWorkingJobId}"
								data-current-permission="${canAddTallyData}"
								data-staff-name="${staffName}"
							>
								${canAddTallyData ? '<i class="far fa-times"></i> Revoke Tally Permission' : '<i class="far fa-check"></i> Grant Tally Permission'}
							</a>
						</div>
					</li>
					<li>
						<div class="dropdown-item">
							<a
								href="#confirmationModal"
								class="btn btn--link"
								data-bs-toggle="modal"
								data-sp-title="Remove Staff"
								data-sp-message="Are you sure you want to remove ${staffName} from this job?"
								data-sp-job="${jobId}"
								data-sp-staff="${staffId}"
								data-sp-role="${roleId}"
								data-sp-action="removeStaffFromJob"
							>
								<i class="far fa-trash-alt"></i> Remove
							</a>
						</div>
					</li>
				</ul>
			</div>
		</td>
    `;

	// Append the new row to the table body
	tableEl.querySelector('tbody').appendChild(newRow);

	// Now count the rows in the table body (excluding any header rows)
	const rowCount = tableEl.querySelectorAll('tbody tr').length;

	// Update the span with the count
	const countSpan = document.getElementById(`countAllocated${roleId}`);

	if (countSpan) {
		countSpan.textContent = rowCount;
	}
};


